'use strict';

angular
	.module('PinMeTo.notifications')
	.service(
		'pmtNotificationService',
		function ($http, $q, $timeout, $stateParams, auth, pmtSiteInfoService) {
			let svc = this;
			svc.notifications = [];
			svc.knownNotificationIds = [];

			let getSiteName = function () {
				return $q.resolve($stateParams.site);
			};

			let subscribers = {};
			function subscribe(key, callback) {
				if (!subscribers[key]) {
					subscribers[key] = [];
				}
				subscribers[key].push(callback);
			}
			function sendMessage(key, msg) {
				subscribers[key].forEach(function (subscriber) {
					subscriber(msg);
				});
			}

			function receiveNotifications(notifications) {
				let n = 0;

				notifications.forEach(function (notification) {
					let exists = svc.knownNotificationIds.find(function (notificationId) {
						return notification._id === notificationId;
					});

					if (!exists) {
						svc.knownNotificationIds.push(notification._id);
						$timeout(function () {
							svc.notifications.push(notification);
							sendMessage('Notifications', svc.notifications);
						}, 200 * n);
						n++;
					}
				});
			}

			function getNotifications() {
				return getSiteName().then(function (siteName) {
					let defer = $q.defer();
					$http
						.get('api/' + siteName + '/notifications')
						.then(function (response) {
							if (response.data.success && response.data.data) {
								defer.resolve(response.data.data);
							} else {
								defer.reject('Something went wrong.');
							}
						})
						.catch(function (error) {
							defer.reject(error);
						});

					return defer.promise;
				});
			}

			function dismissNotification(notification) {
				return getSiteName().then(function (siteName) {
					let defer = $q.defer();
					$http
						.post('api/' + siteName + '/notifications/dismiss/', { _id: notification._id })
						.then(function (response) {
							if (response.data.success && response.data.data) {
								svc.notifications = svc.notifications.filter(function (n) {
									return notification !== n;
								});
								sendMessage('Notifications', svc.notifications);
								defer.resolve();
							} else {
								console.log('Could not dismiss', notification);
								defer.reject(response.data.error);
							}
						})
						.catch(function (error) {
							defer.reject(error);
						});

					return defer.promise;
				});
			}

			function dismissAllNotifications() {
				return getSiteName().then(function (siteName) {
					let defer = $q.defer();

					$http
						.post('api/' + siteName + '/notifications/dismissAll')
						.then(function (response) {
							if (response.data.success) {
								svc.notifications = [];
								sendMessage('Notifications', svc.notifications);
								defer.resolve();
							} else {
								defer.reject('Something went wrong.');
							}
						})
						.catch(function (error) {
							defer.reject(error);
						});

					return defer.promise;
				});
			}

			function subscribeToNotifications(callback) {
				subscribe('Notifications', callback);
				sendMessage('Notifications', svc.notifications);
			}

			svc.dismissNotification = dismissNotification;
			svc.dismissAllNotifications = dismissAllNotifications;
			svc.getNotifications = getNotifications;
			svc.subscribeToNotifications = subscribeToNotifications;

			getSiteName().then(function () {
				pmtSiteInfoService.subscribeToNotifications(receiveNotifications);
			});
		}
	);
